let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7r1dn")).then(() => parcelRequire('4JoeL'));